// Today as yyyy-mm-dd in the browser's own zone (Chile), for date inputs'
// default and max. Not toISOString(): that is UTC, a day ahead from 21:00.
export function hoyLocal() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
